import React, { useState, useEffect } from 'react';
import { Paper, Typography, Grid,  } from '@material-ui/core'
import { useStyles } from './classes'
import * as api from "../../api/index.js";
import DishCard from "../../screens/ViewRestaurant/Card";
const FavoriteMenuItems = () => {
  const classes = useStyles()

  const [data,   setData] = useState([]);;;

  useEffect(() => {
    (async () => {
      const { data } = await api.userFavMenuItem();
      setData(data);
    })();
  }, []);


  return (
    <>
             
        <Typography   className={classes.menuInfo} >
          Favorite Menu Items
        </Typography>
        
        <Paper className={classes.menus}>
        <Grid container spacing={3}>
          {data.map((item, idx) => (

              <Grid item md={6} xs={6}>
                  <DishCard classes={classes} item={item} idx={idx} fMenu={true}/>
              </Grid>    
             
                  ))}

        </Grid>
        </Paper>
                
      
    </>
  )
}

export default FavoriteMenuItems